BrowserInterceptor = ($filter, flash, BrowserService) ->
  options =
    timeOut: "0"

  return flash.error($filter('translate')('_BROWSER.BLOCK_COOKIE_ALERT_MESSAGE'), options) unless BrowserService.isSupportCookie()
  return flash.error($filter('translate')('_BROWSER.PRIVATE_MODE_ALERT_MESSAGE'), options) unless BrowserService.isSupportLocalStorage()

BrowserInterceptor.$inject = [
  '$filter'
  'flash'
  'BrowserService'
]

module.exports = BrowserInterceptor



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/browser/browser-interceptor.coffee